import React from 'react';
import PublicLayoutPage from '../components-app/PublicPageLayout';
import u from '../utilities/Utilities';
import store from 'store';
import {Step,LoadGraphic} from '../components-static/Common';
import qs from 'query-string';
import moment from 'moment';
import '../styles/redirect.scss';

/**
 * How to write a redirect
 * 
 * Mandatory
 *  token - To identify non-user
 *  location - /location, only visible page to a temp user
 * 
 * Option
 *  q - query behind location
 *  
 *  Between queries, use ~
 *  Replace key=value with key:value
 *  
 */
export default class Redirect extends React.Component{

    state={
        step:"loading",
    };

    componentDidMount=()=>{
        this.processLink();
    };

    processLink=()=>{
        const query = qs.parse(this.props.location.search);
        u.post({
            url:"/noauth/login-temp-user",
            data:{
                token:query.token
            },
            success:(cookies)=>{
                for(var key in cookies){
                    store.set(key,cookies[key]);
                }
                store.remove("dashboard-action");
                store.remove("dashboard-action-label");
                store.set("auth",moment().format("YYYY-MM-DDTHH:mm:ss"));
                store.set("tempUser",true);
                store.set("tempLocation",query.location);

                let tempQuery = "";
                if(query.q){
                    let queries = query.q.split("~");
                    for(var i=0; i<queries.length; i++){
                        const qR = queries[i].replace(":","=");
                        tempQuery += ((i==0) ? "?" : "&") + qR;
                    }
                    store.set("tempQuery",tempQuery);
                }
                else{
                    store.remove("tempQuery");
                }

                const location = query.location + tempQuery;
                window.location = location;
            },
            error:(error)=>{
                this.setState({error:error,step:"error"});
            }
        })
    };

    render(){
        return(
            <PublicLayoutPage url="/redirect" title="Redirecting">
                <div style={{textAlign:"center"}}>
                    <div className="redirect-container">
                        <Step active={(this.state.step == "loading")}>
                            <LoadGraphic active={true} text="Redirecting..."/>
                        </Step>
                        <Step active={(this.state.step == "error")}>
                            <h1>{this.state.error}</h1>
                            <div>This page is only accessible through a Smartdorm link, provided via Email</div>
                        </Step>
                    </div>
                </div>
            </PublicLayoutPage>
        );
    }
};